export default __webpack_public_path__ + "3bb73a266adbf68fe844bfa000b0740d.svg";